import { ArrowUpRight, Star } from "lucide-react";
import { HERO } from "@/constants/testIds";
import { SITE, AWARDS, COUPLE_IMAGES } from "@/data/site";
import { useLiveStats } from "@/lib/liveStats";

export default function Hero({ town }) {
  const stats = useLiveStats();
  const headlineLead = town
    ? `The `
    : `The `;
  const headlineHighlight = "most-reviewed";
  const headlineTail = town
    ? ` wedding videographers and photographers in ${town.name}.`
    : ` wedding videographers and photographers in Essex.`;

  const subline = town
    ? `${stats.total} verified 5-star reviews across Hitched, Google, Facebook, Bridebook and Guides for Brides. 1000+ couples filmed across ${town.postcode}.`
    : `${stats.total} verified 5-star reviews across Hitched, Google, Facebook, Bridebook and Guides for Brides. 1000+ couples filmed. Essex Wedding Awards Videographer of the Year.`;

  return (
    <section
      data-testid={HERO.root}
      className="relative overflow-hidden bg-stone-50 grain"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-28 pb-20 md:pb-32 grid md:grid-cols-12 gap-12 items-end">
        <div className="md:col-span-7 fade-up">
          <p className="overline mb-10">
            {town ? `${town.name}, Essex` : "Essex. Established 2015"}
          </p>

          <h1 className="font-serif text-[2.6rem] sm:text-[3.6rem] lg:text-[5.4rem] leading-[1.02] tracking-tight text-stone-900">
            {headlineLead}
            <em className="italic font-normal text-stone-600">{headlineHighlight}</em>
            {headlineTail}
          </h1>

          <p className="mt-8 text-stone-700 text-lg md:text-xl max-w-xl leading-[1.55] font-serif">
            {subline}
          </p>

          {/* Elegant unboxed rating */}
          <div
            data-testid={HERO.ratingBadge}
            className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3"
          >
            <div className="flex items-center gap-1.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#B8923A] text-[#B8923A]" strokeWidth={1} />
              ))}
            </div>
            <p className="font-serif text-stone-900">
              <span className="text-2xl kbd">{stats.rating.toFixed(1)}</span>
              <span className="italic text-stone-500 text-lg ml-2">
                from {stats.total} reviews across Hitched, Google, Facebook, Bridebook and Guides for Brides
              </span>
            </p>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-6">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid={HERO.ctaPrimary}
            >
              Check my date
              <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
            <a
              href="#reviews"
              className="link-elegant"
              data-testid={HERO.ctaSecondary}
            >
              Read {stats.total} reviews
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="mt-16 flex flex-wrap items-center gap-x-12 gap-y-6">
            {AWARDS.map((a) => (
              <img
                key={a.name}
                src={a.img}
                alt={a.name}
                className="h-14 md:h-16 w-auto object-contain opacity-90"
                loading="eager"
              />
            ))}
          </div>
        </div>

        <div className="md:col-span-5 relative h-[440px] md:h-[640px]">
          <div className="absolute top-0 right-0 w-[78%] h-[60%] overflow-hidden">
            <img
              src={COUPLE_IMAGES[0].src}
              alt={COUPLE_IMAGES[0].alt}
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>
          <div className="absolute bottom-0 left-0 w-[58%] h-[52%] overflow-hidden ring-[10px] ring-stone-50">
            <img
              src={COUPLE_IMAGES[1].src}
              alt={COUPLE_IMAGES[1].alt}
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
